<script>
// Dependencies
import Cookies from "js-cookie";

// Prepare constants
const NAMESPACE = "v-cookies";

// Export component
export default {
  props: {
    subscribe: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      reactiveData: {},
      mounted: false
    };
  },
  mounted() {
    // Grab cookies
    this.subscribe.forEach(key => {
      // Map reactive data
      this.$set(this.reactiveData, key, this.getCookie(key));

      // Handle updates
      this.$watch(
        // Subscribe
        vm => [vm.reactiveData[key]],

        // Handle updates
        _ => this.updateCookies(),

        // Config
        { immediate: false }
      );
    });

    // Mark as mounted
    this.mounted = true;
  },
  methods: {
    getCookies() {
      return JSON.parse(Cookies.get(`${NAMESPACE}`) || "{}");
    },
    getCookie(key) {
      // Get list of cookies
      const list = this.getCookies();

      // Return cookie
      return typeof list[key] === "undefined" ? null : list[key];
    },
    updateCookies() {
      Cookies.set(
        `${NAMESPACE}`,
        JSON.stringify({ ...this.getCookies(), ...this.reactiveData })
      );
    }
  },
  render(h) {
    // Skip rendering if unmounted
    if (!this.mounted) return null;

    // Render
    const children = this.$scopedSlots.default(this.reactiveData);
    return h("div", {}, Array.isArray(children) ? children : [children]);
  }
};
</script>
